import React from 'react';
import { Carousel } from 'react-bootstrap';

import '../assets/animate/animate.css';
import './carousel.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const CarouselComponent = () => {
  return (
    <>
      <Carousel fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="img/slider_img3.jpg" // Replace with your image URL
            alt="First slide"
          />
          <Carousel.Caption>
            <div className="carousel-caption">
              <p className="animated fadeInRight">Building Dreams</p>
              <h1 className="animated fadeInLeft">Turning Ideas Into Concrete Reality

</h1>
              <a className="btn animated fadeInUp" href="#">Get A Quote</a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            src="img/slider_img1.jpg" // Replace with your image URL
            alt="Second slide"
          />
          <Carousel.Caption>
            <div className="carousel-caption">
              <p className="animated fadeInRight">We Are Trusted</p>
              <h1 className="animated fadeInLeft"> Experience That Builds With Integrity

</h1>
              <a className="btn animated fadeInUp" href="https://htmlcodex.com/construction-company-website-template">Get A Quote</a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100"
            src="img/rise.png" // Replace with your image URL
            alt="Third slide"
          />
          <Carousel.Caption>
            <div className="carousel-caption">
              <p className="animated fadeInRight">Skilled Workforce</p>
              <h1 className="animated fadeInLeft">Strong Hands, Stronger Foundations</h1>
              <a className="btn animated fadeInUp" href="https://htmlcodex.com/construction-company-website-template">Get A Quote</a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default CarouselComponent;
